import { CreditsCard } from "components/CreditsCard";
import { CreditsTable } from "components/CreditsTable/CreditsTable";
import Loader from "components/DesignSystem/Loader/loader";
import { DocumentPreviewModal } from "components/PreviewModal";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useQuery } from "hooks/useQuery";
import { useGetCreditsQuery } from "store/apis/refrral";

const CreditHistory = () => {
  const query = useQuery();
  const page = Number(query.get("page")) || 1;
  const { uuid: groupId } = useCurrentGroupContext();

  const { isLoading, isSuccess, refetch } = useGetCreditsQuery(
    { groupId, pageNum: page },
    { skip: !groupId }
  );

  if (isLoading || !isSuccess) {
    return <Loader />;
  }

  return (
    <div className="t-pb-16 t-flex t-flex-col t-gap-8">
      <CreditsCard refetch={refetch} />
      <div>
        <div className="t-text-subtitle-lg t-text-text-100">Credit History</div>
        <CreditsTable />
      </div>
      <DocumentPreviewModal />
    </div>
  );
};

export default CreditHistory;
